import { Chip } from '@mui/material'
import { MRT_ColumnDef } from 'material-react-table'
import { LoteProps } from '../../../../interfaces/lote.ts'

export const LoteListadoColumns: MRT_ColumnDef<LoteProps>[] = [
  {
    accessorKey: 'codigoLote',
    header: 'Código',
    enableSorting: true,
    size: 150,
  },
  {
    accessorKey: 'descripcion',
    header: 'Descripción',
    enableSorting: false,
  },

  {
    accessorKey: 'fechaAdmision',
    header: 'Fecha de Admisión',
    enableColumnFilter: false,
    enableSorting: false,
  },
  {
    accessorKey: 'fechaFabricacion',
    header: 'Fecha de Fabricación',
    enableColumnFilter: false,
    enableSorting: false,
    size: 190,
  },
  {
    accessorKey: 'fechaVencimiento',
    header: 'Fecha de Vencimiento',
    enableColumnFilter: false,
    enableSorting: false,
    size: 190,
  },
  {
    accessorKey: 'atributo1',
    header: 'Atributo 1',
    enableSorting: false,
    size: 130,
  },
  {
    accessorKey: 'atributo2',
    header: 'Atributo 2',
    enableSorting: false,
    size: 130,
  },
  {
    accessorFn: (row) => <Chip size={'small'} label={row.state} color={'success'} />,
    id: 'state',
    header: 'Estado',
    enableColumnFilter: false,
    enableSorting: false,
    size: 110,
  },
]
